<template>
  <div>
    <template v-if="test">
      <div class="tab tab--rounded">
        <div class="tab__title result__title h2 text-center">Результаты тестирования {{ test.payload.category_name }}</div>

        <div v-if="test.type === 'ticket'" class="tab__subtitle h3">Билет {{ test.ticket_id}}</div>
        <div v-if="test.type === 'theme'" class="tab__subtitle h3">Тема: {{ test.payload.theme_name }}</div>

        <div class="tab__info">
          <p>дата выполнения: <strong>{{ date }}</strong></p>
          <p v-if="test.user_name">Прошел тестирование: <strong>{{ test.user_name }}</strong></p>
        </div>

        <div class="flex flex-justify-sb result">
          <div class="result-item">
            <span><span class="green">{{ test.results.correct_answers_count}}</span>/{{ test.results.questions_count}}</span>
            правильных ответов</div>
          <div class="result-item">Затраченное время: {{ test.results.taked_time || '&nbsp;&nbsp;—' }}</div>
          <div class="result-item">{{ test.results.wrong_answers_count}} Ошибок {{ test.type === 'ticket' ? "в билете" : '' }}</div>
        </div>

        <div class="tab__button text-center">
          <a href="javascript:void(0)" class="btn btn-blue" @click.prevent="toggleAnswers">
            {{
              isAnswersShown ? "Скрыть ответы" : "Показать ответы"
            }}
          </a>
        </div>
      </div>

      <div v-if="isAnswersShown">
        <answers :answeredQuestions="test.payload.answered_questions" />
      </div>
    </template>
    <template v-else-if="Object.keys(errors.getTestResult).length">
      {{ errors.getTestResult.error || errors.getTestResult.message }}
    </template>
    <template v-else>
      Загрузка...
    </template>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import getFormattedDate from '@/utils/getFormattedDate';
  import Answers from '@/components/pdd/Answers.vue';

  export default {
    name: 'TestResult',
    components: { Answers },
    data() {
      return {
        isAnswersShown: false,
      };
    },
    computed: {
      ...mapState('testResult', ['test', 'errors']),
      date() {
        return this.getFormattedDate(this.test.created_at, 'YYYY-MM-DD HH:mm:ss', 'DD.MM.YYYY, HH:mm');
      },
    },
    async mounted() {
      await this.getTestResult({ uuid: this.$route.params.uuid });
    },
    methods: {
      ...mapActions('testResult', ['getTestResult']),
      getFormattedDate,
      toggleAnswers() {
        this.isAnswersShown = !this.isAnswersShown;
      },

    },
  };
</script>
